import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

const _getFetchParams = selectedMonth => ({
    month: Math.floor(selectedMonth / TIMESTAMP_MULTIPLY)
});

module.exports = {
    createFetchParams: selectedMonth => _getFetchParams(selectedMonth),
    ...storeModuleFactory({
        name:               'cloudBillingResume',
        endpoint:           endpoints.cloudBilling.monthTotal,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => ({
            selectedMonthSpending: item.selected,
            previousMonthSpending: item.previous
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/cloudBillingResume.js